// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// 引入ElementUI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// 引入初始化css样式
import './assets/styles/reset.css'
import 'swiper/dist/css/swiper.css'
// 引入公共css
import './assets/styles/common.css'
import './permission'

import Vue from 'vue'
// 复制剪切板
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
import VueMarquee from 'vue-marquee-component'

import App from './App'
// 引入axios
import axios from 'axios'
axios.defaults.withCredentials = true;


import VueAxios from 'vue-axios'
// 引入vuex(状态管理)
// import vuex from 'vuex'
import store from './store'
// import Mock from './mock'
// Mock.bootstrap()
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')

Vue.use(VideoPlayer)
import remAndPhoneConfig from './config/remConfig';

import VueAwesomeSwiper from 'vue-awesome-swiper';
Vue.use(VueAwesomeSwiper)
Vue.use(VueMarquee)

import router from './router'
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(VueAxios, axios)
// Vue.use(vuex)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})








// WEBPACK FOOTER //
// ./src/main.js